// this file was auto-generated by the `yarn generate:image-sizes` script

export default {
    p1: {
        '1/1': {
            width: 107,
            height: 107,
        },
        '4/3': {
            width: 107,
            height: 80,
        },
        '3/4': {
            width: 107,
            height: 143,
        },
        '5/4': {
            width: 107,
            height: 86,
        },
    },
    p2: {
        '1/1': {
            width: 214,
            height: 214,
        },
        '4/3': {
            width: 214,
            height: 161,
        },
        '3/4': {
            width: 214,
            height: 285,
        },
        '5/4': {
            width: 214,
            height: 171,
        },
    },
    p3: {
        '1/1': {
            width: 321,
            height: 321,
        },
        '4/3': {
            width: 321,
            height: 241,
        },
        '3/4': {
            width: 321,
            height: 428,
        },
        '5/4': {
            width: 321,
            height: 257,
        },
    },
    p4: {
        '1/1': {
            width: 448,
            height: 448,
        },
        '4/3': {
            width: 448,
            height: 336,
        },
        '3/4': {
            width: 448,
            height: 597,
        },
        '5/4': {
            width: 448,
            height: 358,
        },
    },
    d1: {
        '1/1': {
            width: 106,
            height: 106,
        },
        '4/3': {
            width: 106,
            height: 80,
        },
        '3/4': {
            width: 106,
            height: 141,
        },
        '5/4': {
            width: 106,
            height: 85,
        },
    },
    d2: {
        '1/1': {
            width: 213,
            height: 213,
        },
        '4/3': {
            width: 213,
            height: 160,
        },
        '3/4': {
            width: 213,
            height: 284,
        },
        '5/4': {
            width: 213,
            height: 170,
        },
    },
    d3: {
        '1/1': {
            width: 319,
            height: 319,
        },
        '4/3': {
            width: 319,
            height: 239,
        },
        '3/4': {
            width: 319,
            height: 425,
        },
        '5/4': {
            width: 319,
            height: 255,
        },
    },
    d4: {
        '1/1': {
            width: 425,
            height: 425,
        },
        '4/3': {
            width: 425,
            height: 319,
        },
        '3/4': {
            width: 425,
            height: 567,
        },
        '5/4': {
            width: 425,
            height: 340,
        },
    },
    d5: {
        '1/1': {
            width: 532,
            height: 532,
        },
        '4/3': {
            width: 532,
            height: 399,
        },
        '3/4': {
            width: 532,
            height: 709,
        },
        '5/4': {
            width: 532,
            height: 426,
        },
    },
    d6: {
        '1/1': {
            width: 638,
            height: 638,
        },
        '4/3': {
            width: 638,
            height: 479,
        },
        '3/4': {
            width: 638,
            height: 851,
        },
        '5/4': {
            width: 638,
            height: 510,
        },
    },
    d7: {
        '1/1': {
            width: 744,
            height: 744,
        },
        '4/3': {
            width: 744,
            height: 558,
        },
        '3/4': {
            width: 744,
            height: 992,
        },
        '5/4': {
            width: 744,
            height: 595,
        },
    },
    d8: {
        '1/1': {
            width: 851,
            height: 851,
        },
        '4/3': {
            width: 851,
            height: 638,
        },
        '3/4': {
            width: 851,
            height: 1135,
        },
        '5/4': {
            width: 851,
            height: 681,
        },
    },
    d9: {
        '1/1': {
            width: 957,
            height: 957,
        },
        '4/3': {
            width: 957,
            height: 718,
        },
        '3/4': {
            width: 957,
            height: 1276,
        },
        '5/4': {
            width: 957,
            height: 766,
        },
    },
    d10: {
        '1/1': {
            width: 1063,
            height: 1063,
        },
        '4/3': {
            width: 1063,
            height: 797,
        },
        '3/4': {
            width: 1063,
            height: 1417,
        },
        '5/4': {
            width: 1063,
            height: 850,
        },
    },
    d11: {
        '1/1': {
            width: 1170,
            height: 1170,
        },
        '4/3': {
            width: 1170,
            height: 878,
        },
        '3/4': {
            width: 1170,
            height: 1560,
        },
        '5/4': {
            width: 1170,
            height: 936,
        },
    },
    d12: {
        '1/1': {
            width: 1312,
            height: 1312,
        },
        '4/3': {
            width: 1312,
            height: 984,
        },
        '3/4': {
            width: 1312,
            height: 1749,
        },
        '5/4': {
            width: 1312,
            height: 1050,
        },
    },
}
